/* Progressive enhancement only: the full sourced reference is in the page HTML. */
(() => {
  'use strict';
  const init = (root) => {
    if (root.dataset.mmShortcutReady) return;
    const table = root.querySelector('[data-mm-shortcut-table]');
    const os = root.querySelector('[data-mm-shortcut-os]');
    const app = root.querySelector('[data-mm-shortcut-app]');
    const controls = root.querySelector('[data-mm-shortcut-controls]');
    const status = root.querySelector('[data-mm-shortcut-status]');
    const copy = root.querySelector('[data-mm-shortcut-copy]');
    const reset = root.querySelector('[data-mm-shortcut-reset]');
    const fallback = root.querySelector('[data-mm-shortcut-fallback]');
    const copyText = root.querySelector('[data-mm-shortcut-copy-text]');
    if (!table || !os || !app || !controls || !status || !copy || !reset || !fallback || !copyText) return;
    root.dataset.mmShortcutReady = 'true';
    controls.hidden = false;
    const rows = [...table.querySelectorAll('tbody tr[data-mm-app]')];
    const compact = (node) => {
      // Exclude the alternate OS even when a browser's textContent includes hidden text.
      const clone = node.cloneNode(true);
      clone.querySelectorAll('[hidden]').forEach((hidden) => hidden.remove());
      return clone.textContent.replace(/\s+/g, ' ').trim();
    };
    const update = () => {
      table.dataset.mmKeyboard = os.value;
      rows.forEach((row) => { row.hidden = app.value !== 'all' && row.dataset.mmApp !== app.value; });
      table.querySelectorAll('[data-mm-os]').forEach((cell) => {
        cell.hidden = os.value !== 'all' && cell.dataset.mmOs !== os.value;
      });
      fallback.hidden = true;
      const count = rows.filter((row) => !row.hidden).length;
      const keyboard = os.options[os.selectedIndex].textContent;
      status.textContent = `${count} ${count === 1 ? 'app' : 'apps'} · ${keyboard}`;
    };
    const cheatSheet = () => {
      const labels = [...table.querySelectorAll('thead th')].filter((cell) => !cell.hidden).map(compact);
      const sections = rows.filter((row) => !row.hidden).map((row) => {
        const values = [...row.children].filter((cell) => !cell.hidden).map(cell => compact(cell.querySelector('[data-mm-app-name]') || cell));
        const source = row.dataset.mmShortcutSource;
        const setup = row.querySelector('[data-mm-config-link]');
        return values.map((value, index) => `${labels[index]}: ${value}`).join('\n') + (source ? `\nOfficial source: ${source}` : '') + (setup ? `\nConfigure with MuteMe: ${setup.href}` : '');
      });
      return 'MuteMe meeting mute shortcuts\nReviewed October 8, 2026\n\n' + sections.join('\n\n') +
        '\n\nThese are app defaults, not a system-wide mute guarantee. Custom keybinds, focus, settings, keyboard layout, and host permissions can affect behavior. Check the microphone icon after using a shortcut.\nGuide: https://muteme.com/pages/mute-shortcuts';
    };
    os.addEventListener('change', update);
    app.addEventListener('change', update);
    reset.addEventListener('click', () => { os.value = 'all'; app.value = 'all'; update(); });
    copy.addEventListener('click', async () => {
      const value = cheatSheet();
      copy.disabled = true;
      try {
        if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(value);
        fallback.hidden = true;
        status.textContent = 'Copied your selected cheat sheet to the clipboard.';
      } catch (_) {
        fallback.hidden = false;
        copyText.value = value;
        copyText.focus();
        copyText.select();
        status.textContent = 'Automatic copying is unavailable. Copy the selected text in the cheat sheet box.';
      } finally {
        copy.disabled = false;
      }
    });
    update();
  };
  const start = () => document.querySelectorAll('[data-mm-mute-shortcuts]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
